exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".questions-bg[data-v-ae14f946]{margin-top:.76rem;width:95%;margin-left:2.5%;background:#f7f7f7;border:1px solid #eeeff1;border-radius:.12rem;text-align:center}.questions-bg img[data-v-ae14f946]{width:1.6rem;height:1.42rem;margin-top:.76rem}.questions-bg p[data-v-ae14f946]{width:100%;font-size:.28rem;color:#19191a;letter-spacing:.5px;text-align:center;line-height:.48rem}.questions-bg .result[data-v-ae14f946]{margin-top:.82rem}.questions-bg .result span[data-v-ae14f946]{color:#ff5714}.questions-bg .btn[data-v-ae14f946]{width:90%;height:.92rem;line-height:.92rem;margin:.6rem 0 .56rem 5%;font-size:.3rem;color:#fff;border-radius:2px;background-image:linear-gradient(269deg,#3b414d,#262a32)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ae14f946","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/recruit-answer/components/Success.vue
// module id = +jPO
// module chunks = 1